import React, { useState } from "react";
import "./index.css";
import { Outlet } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import UnauthorizedUI from "./components/unauthorizedUi/unauthorizedUi";
import { COURSE_ADMIN_PERMISSION } from "../../../utils/constants/permissionNodes";
import Loading from "../../components/loading";
import {
  Box,
  Collapse,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import NavigationBar from "./components/NavigationBar";
import AdminDialog from "./components/adminDialog/AdminDialog";
import { useAppSelector } from "../../../reduxStore/hooks";
import { RootState } from "../../../reduxStore/store";
import { DOMAIN_CONFIG_OBJ } from "../../../utils/axiosInstance";
import { QBOOK_DOMAIN_VALUES } from "../../../utils/constants/domainNameValues";
type Props = {};
const NAV_WIDTH=260
const AdminLayout = (props: Props) => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("lg"));
  const { openAdminDialog } = useAppSelector(
    (state: RootState) => state.adminDialog
  );
  const { userData, isLoading: userLoading } = useAppSelector(
    (state: RootState) => state.auth
  );
  const { isDark } = useAppSelector((state) => state.theme);
  const [showSideBar, setShowSideBar] = useState<boolean>(false);
  const [attachSideBar, setAttachSideBar] = useState<boolean>(false);

  const handleDrawerToggle = () => {
    setAttachSideBar((pre) => !pre);
  };
  return (
    <div
      className="admin-parent-container"
      style={{ background: theme.palette.background.adminBg }}
    >
      {userLoading ? (
        <Loading />
      ) : !userLoading &&
        userData?.permissionsNodes?.includes(COURSE_ADMIN_PERMISSION) ? (
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent={isMobileView ? "space-between" : "flex-end"}
          flexDirection={isMobileView ? "column" : "row"}
          width="100dvw"
          maxHeight="100vh"
          overflow="hidden"
          sx={{
            position: "relative",
          }}
        >
          {isMobileView && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                px: "1.5em",
              }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
              <img
                src={
                  DOMAIN_CONFIG_OBJ.domainName === QBOOK_DOMAIN_VALUES.quera
                    ? isDark
                      ? DOMAIN_CONFIG_OBJ.darkThemeLogo
                      : DOMAIN_CONFIG_OBJ.lightThemeLogo
                    : DOMAIN_CONFIG_OBJ.simpleLogo
                }
                className={
                  DOMAIN_CONFIG_OBJ.domainName !== QBOOK_DOMAIN_VALUES.quera
                    ? "navigation-logo"
                    : "navigation-logo-quera"
                }
                style={{ objectFit: "contain" }}
                alt="navigation"
              />
            </Box>
          )}
          {!isMobileView && (
            <Collapse
              orientation="horizontal"
              in={true}
              collapsedSize={NAV_WIDTH}
              sx={{
                position: attachSideBar ? "sticky" : "absolute",
                left: 0,
                zIndex: 1200,
                maxWidth: NAV_WIDTH,
              }}
            >
              <Box
                pt="1rem"
                onMouseEnter={() => setShowSideBar(true)}
                onMouseLeave={() => setShowSideBar(false)}
                sx={{
                  width:NAV_WIDTH,
                  top: 0,
                  height: "100vh",
                  overflow: "auto",
                  zIndex: "1200",
                  background: theme?.palette?.adminNav?.background1,
                  boxShadow: theme?.palette?.adminNav?.shadow,
                }}
              >
                <NavigationBar
                  showSideBar={true}
                  setAttachSideBar={setAttachSideBar}
                  attachSideBar={attachSideBar}
                />
              </Box>
            </Collapse>
          )}
          {isMobileView && (
            <nav>
              <Drawer
                variant="temporary"
                open={attachSideBar}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: {
                    xs: "block",
                    sm: "block",
                    md: "block",
                    lg: "none",
                  },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    px: "1em",
                    background: theme?.palette?.adminNav?.background1,
                  },
                }}
              >
                <NavigationBar
                  showSideBar={attachSideBar || showSideBar}
                  setAttachSideBar={setAttachSideBar}
                  attachSideBar={true}
                  isMobileView={isMobileView}
                />
              </Drawer>
            </nav>
          )}

          <Box
            sx={{
              minHeight: "100vh",
              maxHeight: "100vh",
              overflowY: "auto",
              overflowX: "hidden",
              width: {
                xs: "100%",
                sm: "100%",
                md: "100%",
                lg: `calc(100% - ${NAV_WIDTH}px)`,
              },
              padding: {
                lg: `1rem`,
                md: "1rem 0",
                sm: "0",
                xs: "0",
              },
            }}
            cy-data="qbook-admin-layout-container"
          >
            <Outlet />
          </Box>
          {openAdminDialog && <AdminDialog />}
        </Box>
      ) : (
        <UnauthorizedUI />
      )}
    </div>
  );
};

export default AdminLayout;
